export default "__VITE_ASSET__CcBJGmiC__"